import { styled } from '@mui/material/styles';
import { Drawer as MuiDrawer, Box, Link } from '@mui/material';
import { neutral, primary } from '_lex/_foundations/phxColors';

const drawerWidth = 300;

interface DrawerProps {
  open?: boolean;
}

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<DrawerProps>(({ theme, open }) => ({
  height: '100%',
  '& .MuiDrawer-paper': {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: open ? drawerWidth : 72,
    backgroundColor: primary[900],
    overflowX: 'hidden',
    height: '100%',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.easeInOut,
      duration: 800,
    }),
    boxSizing: 'border-box',
  },
}));

export const SecondaryDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})<DrawerProps>(({ theme, open }) => ({
  alignSelf: 'stretch',
  height: '100%',
  '& .MuiDrawer-paper': {
    position: 'relative',
    width: open ? drawerWidth : 0,
    backgroundColor: neutral[25],
    boxShadow: theme.shadows[4],
    opacity: open ? 1 : 0,
    transition: theme.transitions.create(['width', 'opacity'], {
      easing: theme.transitions.easing.easeInOut,
      duration: 300,
    }),
    overflow: 'hidden',
    height: '100%',
    maxHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      minWidth: drawerWidth,
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
  },
}));

const navItemButtonStyles = {
  color: neutral[25],
  backgroundColor: 'transparent',
  padding: '12px !important',
  borderRadius: 8,
  justifyContent: 'flex-start',
  height: 48,
  width: '100%',
  cursor: 'pointer',
  textDecoration: 'none',
  display: 'inline-flex',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    textDecoration: 'none',
  },
  '&.active': {
    color: neutral[25],
    backgroundColor: primary[800],
  },
};

export const NavItemButton = styled(Link)(() => navItemButtonStyles);

export const NavItemButtonNoLink = styled(Box)(() => ({
  ...navItemButtonStyles,
  border: 'none',
  outline: 'none',
  font: 'inherit',
}));

export const SecondaryNavItemButton = styled(Link)(() => ({
  color: neutral[600],
  backgroundColor: 'transparent',
  padding: '12px 16px',
  borderRadius: 8,
  minHeight: 48,
  width: '100%',
  fontSize: '16px',
  fontWeight: 400,
  textAlign: 'left',
  justifyContent: 'flex-start',
  textTransform: 'none',
  cursor: 'pointer',
  textDecoration: 'none',
  display: 'inline-flex',
  '&:hover': {
    backgroundColor: neutral[100],
    textDecoration: 'none',
  },
  '&.active': {
    color: neutral[600],
    backgroundColor: neutral[200],
  },
}));
